export default __webpack_public_path__ + "static/media/image.rameca-technology-solutions-pvt-ltd.d37302ff.png";